import React, { Component } from 'react';
import style from './style.scss';



import CallsListContainer from '../CallsList/CallsListContainer';
import CallbacksListContainer from '../../callbacks/CallbacksList/CallbacksListContainer';
import Modal from '../../common/Modal/Modal';

export default class CallsPage extends Component{

  constructor(props) {
    super(props);

    this.state = {
      calls: null,
      showInstructions: false,
    };
  }

  componentWillReceiveProps(){

    const {app_data, history} = this.props;
    const role = app_data.roles[app_data.user.role_id];

    if(!role.access.calls) {
      history.push(role.default_page);
    }

  }

  render() {

    const {app_data, history} = this.props;
    const {calls} = this.state;

    return (
      <div className={`container calls_page`}>
        <div 
          className="calls_page__instructions_button button button_green"
          onClick={() => {
            this.setState({
              showInstructions: true,
            });
          }}
        >
          Инструкция менеджера
        </div>
        <div className="calls_page__callbacks">
          <CallbacksListContainer calls={calls} app_data={app_data} />;
        </div>

        <div  className="calls_page__calls">
          <CallsListContainer onLoad={(calls) => {
            if(calls) {
              const old_calls_json = this.state.calls ? JSON.stringify(this.state.calls) : '';
              const new_calls_json = JSON.stringify(calls);

              if(old_calls_json !== new_calls_json) {
                this.setState({
                  calls
                });
              }
            }
          }} app_data={app_data} />;
        </div>

        {this.state.showInstructions && (
          <Modal 
            onClose={() => {
              this.setState({
                showInstructions: false,
              })
            }}
            extraClass=""
          >
            <p>
              <b>09:00</b> - Обзвон пропущенных вызовов и заявок;
            </p>
            <p>
              <b>09:00-11:00</b>
              <ul>
                <li>Распечатать курьеру документы;</li>
                <li>Подготовить устройства к отправке (телевизоры, ноутбуки);</li>
                <li>Обзвон законченных устройств;</li>
              </ul>
            </p>
            <p>
              <b>11:00-14:00</b>
              <ul>
                <li>Обзвон вчерашнего дня;</li>
                <li>Проверить просроченные заказы;</li>
              </ul>
            </p>
            <p>
              <b>11:00-21:00</b>
              <ul>
                <li>Поиск и заказ запчастей; </li>
                <li>Отвечать в Вайбере по битым ТВ;</li>
                <li>Проверять просроченные заказы</li>
              </ul>
            </p>
            <p><b>15:00</b> - Промежуточный свод кассы</p> 
            <p><b>19:00</b> - Промежуточный  свод кассы</p> 
            <p>
              <b>21:00 </b>
              <ul>
                <li>Приёмка у курьера устройств;</li>
                <li>Итоговый свод кассы и отправка отчета </li>
                <li>Cравнить чеки безнал;</li>
                <li>Проверить просроченные заказы;</li>
              </ul>
            </p>
          </Modal>
        )}    
      </div>
    );
  }
}

